require('./aggregatorProductsGenericView.scss')

import React from 'react';
import PropTypes from 'prop-types';

import { OKHeaderSubPage } from 'commonsComponents/OKHeaderSubPage';
import { OKCover } from 'commonsComponents/OKCover';
import { OKButton } from 'components/commons/OKButton/OKButton';

import OKTooltip from 'components/commons/OKTooltip/OKTooltip';

import { getLastNChars } from 'utilities/stringHelper';
import { sendTextToClipBoard } from 'commonsUtilities/clipBoardHelper';

const { FormattedText } = require('core/i18n').i18n;

class AggregatorProductsGenericView extends React.PureComponent {
    handleCopyIbanToClipBoard = () => {
        sendTextToClipBoard(this.props.subtitle)
    }

    buildTooltipContent = (iban) => {
        return (
            <span>
                {iban}
                <button
                    className="icon__tooltip icon-copiar"
                    onClick={this.handleCopyIbanToClipBoard}
                >
                </button>
            </span>
        );
    }

    render(){
        const { title, subtitle, renderHeaderDetails, children, breadcrumb } = this.props

        const subtitleFormatted = <span className="aggregator-generic-product-view__iban">{getLastNChars(`${subtitle}`)}</span>;
        const button = (
            <div className="aggregator-generic-product-view__details__button">
                <OKButton
                    modifier="ghost"
                    to="/myprofile/global/entities/add"
                >
                    <FormattedText value="aggregator-addEntityButton" />
                </OKButton>
            </div>
        );
        const header = renderHeaderDetails(button)
        const tooltipContent = this.buildTooltipContent(subtitle);
        const subtitleTooltip = (
            <OKTooltip
                content={tooltipContent}
                offset={[120, 10]}
                placement="bottom"
                target={subtitleFormatted}
            />
        )

        return (
            <div className="aggregator-generic-product-view">
                <div className="container-fluid aggregator-generic-product-view__header">
                    <div className="row">
                        <OKCover size="medium" section="accounts" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={breadcrumb}
                                finalTitle={title}
                                subtitleLeft={subtitleTooltip}
                                ellipsis={true}
                            >
                                {header}
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid grid-view--content-position-negative">
                        <div className="aggregator-generic-product-view__content">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
AggregatorProductsGenericView.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    renderHeaderDetails: PropTypes.func,
    children: PropTypes.element,
    breadcrumb: PropTypes.array
}

export { AggregatorProductsGenericView }
